import { termosStep } from '../../shared/termosSections';
import { juntadaSociedadeStep } from '../../shared/juntadaSections';

const pedidoJuntadaDiligenciaSociedadeConfig = {
  id: 'pedido_juntada_diligencia_sociedade',
  nome: 'Pedido de Juntada de Diligência - Sociedade',
  descricao: 'Solicitação de juntada de diligência relativa à sociedade',
  icon: 'FaFileContract',
  categoria: 'sociedades',

  documentConfig: {
    documentosAdicionais: true,
    required: [
      { id: 'manifestacaoDiligencia', tipoDocumentoProcesso: 488, name: 'Manifestação - Diligência', description: 'Documento contendo a manifestação da diligência', required: true }
    ]
  },

  paymentConfig: {
    amount: 0
  },

  protocoloConfig: {
    modeloRequerimento: '286',
    tiposAssunto: '826',
    tipoPedido: '483'
  },

  // Sem dadosRequerimentoConfig: só nome/documento de quem protocola e da
  // sociedade, sem endereço — nada mapeado em DadosRequerimento hoje.

  steps: [
    juntadaSociedadeStep(),
    termosStep()
  ]
};

export default pedidoJuntadaDiligenciaSociedadeConfig;
